import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/steam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2l-59.2 85.7c-15.5-0.9-30.7 3.4-43.5 12.1l-133.1-55c10.2-127.7 117.1-228.1 247.6-228.1 137.2 0 248.4 111 248.4 248zM155.7 384.3c19.8 8.2 42.5-1.1 50.8-21 8.3-19.8-1.1-42.5-20.9-50.7l-31.5-13c12.2-4.6 26-4.8 38.9 0.6 13 5.4 23.1 15.6 28.5 28.6s5.3 27.3-0.1 40.3c-11.2 26.8-42.1 39.6-69 28.4-10.2-4.3-22.4-15.8-27.2-25.8zM329.5 254.4c-34.4 0-62.4-28-62.4-62.3 0-34.3 28-62.3 62.4-62.3s62.4 28 62.4 62.3c0 34.3-27.9 62.3-62.4 62.3zM329.6 238.8c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8-25.9 0-46.9 21-46.9 46.8 0.1 25.8 21.1 46.8 46.9 46.8z'
      }
    ]
  }
})
